<template>
  <div class="my-machines-custom-vehicle-data">
    <!-- CUSTOM VEHICLE NODES -->
    <div class="my-machines-custom-vehicle-data__nodes">
      <h2 class="h3-semi-bold">
        {{ t('addedVehiclesTitle') }}
      </h2>
      <p class="body-italic">
        *{{ t('addedVehiclesDisclaimer') }}
      </p>
      <oie-my-machines-custom-vehicle-nodes-tree></oie-my-machines-custom-vehicle-nodes-tree>
    </div>

    <!-- CUSTOM MACHINE FILEDS -->
    <div class="my-machines-custom-vehicle-data__fields">
      <h2 class="h3-semi-bold">
        {{ t('addedFieldsTitle') }}
      </h2>
      <oie-hover-list class="my-machines-custom-vehicle-data__list">
        <li v-for="item in machineCustomFieldOptions" :key="item.id">
          <oie-editable-content :display-value="item.text" @change="updateCustomField({id: item.value, name: $event})" @delete="handleDelete(item)"></oie-editable-content>
        </li>
      </oie-hover-list>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('myMachines', ['customVehicles', 'machineCustomFieldOptions'])
  },
  methods: {
    ...mapActions('myMachines', ['updateCustomField', 'deleteCustomField']),
    handleDelete(item) {
      this.publish('modal.show.generic', {
        header: `${this.t('deleteModalHeading')}: ${item.name}?`,
        text: this.t('genericWarningText'),
        buttons: [ {
          text: this.tStatic('genericDelete'),
          usePrimaryButton: true,
          handler: async () => {
            await this.deleteCustomField({ id: item.id })
            this.publish('modal.hide.generic')
          }
        }]
      })
    }
  }

}
</script>

<style lang="scss">
.my-machines-custom-vehicle-data >*:not(:last-child) {
  margin-bottom: measure(double);
}

.my-machines-custom-vehicle-data__nodes,
.my-machines-custom-vehicle-data__fields {
  display: flex;
  flex-direction: column;
  gap: measure(quarter);
}

.my-machines-custom-vehicle-data__fields {
  width: 25rem;
}

</style>
